module.exports = __webpack_public_path__ + "static/media/date-picker.8834742d.svg";